import { useRequestController } from '@sg/hooks/useRequestController';
import type { ILiveTitleCondData } from '@sg/pages/StudioManagement/LiveTitles/hooks';
import React, { FC, useMemo } from 'react';
import { transformData } from '@sg/pages/StudioManagement/LiveTitles/utils';
import NewRegionSelect from '@home/components/NewRegionSelect';
import IconTipsCom from '@sg/components/IconTipsCom';
import { LANGUAGE_EN } from '@home/_config/config';
import { isEmpty } from 'lodash-es';

interface Props {
  /** When provided, skips an internal cond fetch (parent already fetched). */
  liveTitleCondData?: ILiveTitleCondData | null;
  /** Parent owns the cond request; block child fetch even while data is loading. */
  sharedCondFetch?: boolean;
  [key: string]: unknown;
}

const ALL_MARKETS_INFO =
  'Display data results based on de-duplicated users in all markets.';

const LiveRegionFilter: FC<Props> = ({
  value,
  onChange,
  liveTitleCondData,
  sharedCondFetch = false,
  ...restProps
}) => {
  const { data: fetchedCondData } = useRequestController({
    method: 'POST',
    url: '/api/v1/globalpedia_pc/cond',
    staleTime: 300000,
    ready: !sharedCondFetch,
    refreshDeps: useMemo(
      () => ({
        live_title_country_code: null,
        live_title_os: null,
        live_title_studio_game: null,
      }),
      [],
    ),
  });
  const data = liveTitleCondData ?? fetchedCondData;

  const list = useMemo(() => {
    const dataSource = transformData(data?.live_title_country_code);
    return dataSource?.filter(task => task.value !== '255');
  }, [data?.live_title_country_code]);

  const radioOptions = [
    {
      value: '255',
      text: 'All',
      textCN: 'All',
      infoIcon: (
        <IconTipsCom
          tipString={ALL_MARKETS_INFO}
          mWidth={360}
          style={{ width: 14, height: 14 }}
        />
      ),
    },
  ];
  return (
    <NewRegionSelect
      value={value}
      // className={className}
      //     matchButtonWidth: true,
      style={{ marginRight: 10 }}
      local={LANGUAGE_EN}
      // dropdownClassName='region-selector-dropdown'
      radioOptions={radioOptions}
      options={list || []}
      onCloseReginSelect={(value) => {
        if (isEmpty(value.markets)) {
          value.markets = ['255'];
        }
        onChange?.(value);
      }}
      closeOnScroll={true}
      popularList={['br', 'mx', 'ru', 'tr', 'us']}
      // locale={locale} // Temporarily disabled - force English (Correct evrison !! Do not remove)
      locale={LANGUAGE_EN} // Force English locale (Temporary method to disable CN version)
      // activeTab={activeTab}
      // onTabChange={onTabChange}
      {...restProps}
    />
  );
};

export default LiveRegionFilter;
